import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { ChangeEvent } from "react";

interface OpellaHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  totalCount: number;
  filteredCount: number;
}

export function OpellaHeader({
  search,
  onSearchChange,
  totalCount,
  filteredCount,
}: OpellaHeaderProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  const handleClear = () => {
    onSearchChange("");
  };

  const isFiltered = filteredCount !== totalCount;

  return (
    <header className="opella-hero">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-6 p-10">
        <div className="flex items-start justify-between gap-6">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <span className="opella-wordmark">opella</span>
              <span className="opella-pill" aria-label="Collection scope">
                Global Asset Library
              </span>
            </div>
            <h1
              className="text-[28px] font-semibold tracking-tight"
              style={{ color: "var(--opella-fg)" }}
            >
              Brand video library
            </h1>
            <p
              className="max-w-2xl text-sm"
              style={{ color: "var(--opella-fg-secondary)" }}
            >
              Browse approved creative across every market. Preview, select, and
              send assets into review without leaving Opella.
            </p>
          </div>
          <div
            className="text-right text-sm"
            style={{ color: "var(--opella-muted)" }}
            aria-live="polite"
          >
            {isFiltered
              ? `Showing ${filteredCount} of ${totalCount} videos`
              : `${totalCount} videos`}
          </div>
        </div>

        <div className="relative w-full max-w-xl">
          <MagnifyingGlass
            size={18}
            weight="bold"
            className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2"
            style={{ color: "var(--opella-muted)" }}
            aria-hidden
          />
          <input
            type="search"
            className="opella-input pl-11 pr-10"
            placeholder="Search by title or brand"
            aria-label="Search videos by title or brand"
            value={search}
            onChange={handleChange}
          />
          {search.length > 0 ? (
            <button
              type="button"
              onClick={handleClear}
              aria-label="Clear search"
              className="absolute right-3 top-1/2 -translate-y-1/2 p-1"
              style={{ color: "var(--opella-muted)" }}
            >
              <X size={16} weight="bold" aria-hidden />
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
}
